// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"248":"aa49f6ad9a0590f3","251":"605a4d1d0bee0bc5","500":"a224db3243a404d2","781":"26157369b3f10a62"}[chunkId] + ".js";
};